import React from 'react'

import {FieldPopoverMenuProps} from "../../../dropdown/components/popover/popover-menu"
import FieldTags from "../../tags"
import FieldTags_PopoverTagOption from "./tag-option"
import {SortDirection} from "../../../../../data-structures/sort"

type Props = {
    searchString? : string
} & FieldPopoverMenuProps

export default function FieldTags_PopoverTagsList(props:Props) {

    let options : Option[] = props.field.getOptions().slice()

    // filter options by search string
    if (props.searchString) {
        const searchString = props.searchString.toLowerCase()
        options = _(options)
            .filter(option => option.label!.toLowerCase().includes(searchString))
            .value()
    }

    const sortPositions = gd.user.settings.menu.projectsTags.sortPositions
    options = _(options)
        .orderBy([
            option => sortPositions?.includes(option.value) ? 0 : 1,
            option => option.label!.toLowerCase()
        ], [
            SortDirection.ASC,
            SortDirection.ASC
        ])
        .value()

    const field : FieldTags = props.field as unknown as FieldTags

    let selectedTagIds : any[]
    if (props.parent.state.currentOptions) {
        selectedTagIds = props.parent.state.currentOptions
    } else {
        selectedTagIds = field.getViewValue(props.model) || []
    }

    if (_.isEmpty(options)) {
        const message = props.searchString ? 'No match found' : 'No tags found'
        return (
            <div className="flex-column-left-top p-h-15">
                <div className="flex-row-left-center w-100-percent h-36 ui5-txt-no-accent-default">
                    {message}
                </div>
            </div>
        )
    }

    return (
        <div className="flex-column-left-top p-h-15">
            {_.map(options, (option)=>{

                // if (selectedTagIds.includes(option.value)) return null

                return <FieldTags_PopoverTagOption key          = {option.value}
                                                   option       = {option}
                                                   isSelected   = {selectedTagIds.includes(option.value)}
                                                   onClick      = {props.parent.onOptionClick}/>
            })}
        </div>
    )
}
